import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/OutdoorSwing/1_1x.png`;
const Pic2 = `${FullPath}/OutdoorSwing/2_1x.png`;
const Pic3 = `${FullPath}/OutdoorSwing/3_1x.png`;
const Pic4 = `${FullPath}/OutdoorSwing/4_1x.png`;
const Pic5 = `${FullPath}/OutdoorSwing/5_1x.png`;
const Pic6 = `${FullPath}/OutdoorSwing/6_1x.png`;
const Pic7 = `${FullPath}/OutdoorSwing/7_1x.png`;
const Pic8 = `${FullPath}/OutdoorSwing/8_1x.png`;
const Pic9 = `${FullPath}/OutdoorSwing/9_1x.png`;
const Pic10 = `${FullPath}/OutdoorSwing/10_1x.png`;
const Pic11 = `${FullPath}/OutdoorSwing/11_1x.png`;
const Pic12 = `${FullPath}/OutdoorSwing/12_1x.png`;
const Pic13 = `${FullPath}/OutdoorSwing/13_1x.png`;
const Pic14 = `${FullPath}/OutdoorSwing/14_1x.png`;
const Pic15 = `${FullPath}/OutdoorSwing/15_1x.png`;
const Pic16 = `${FullPath}/OutdoorSwing/16_1x.png`;
const Pic17 = `${FullPath}/OutdoorSwing/17_1x.png`;
const Pic18 = `${FullPath}/OutdoorSwing/18_1x.png`;
const Pic19 = `${FullPath}/OutdoorSwing/19_1x.png`;
const Pic20 = `${FullPath}/OutdoorSwing/20_1x.png`;
const Pic21 = `${FullPath}/OutdoorSwing/21_1x.png`;
const Pic22 = `${FullPath}/OutdoorSwing/22_1x.png`;
const Pic23 = `${FullPath}/OutdoorSwing/23_1x.png`;
const Pic24 = `${FullPath}/OutdoorSwing/24_1x.png`;
const Pic25 = `${FullPath}/OutdoorSwing/25_1x.png`;
const Pic26 = `${FullPath}/OutdoorSwing/26_1x.png`;
const Pic27 = `${FullPath}/OutdoorSwing/27_1x.png`;
const Pic28 = `${FullPath}/OutdoorSwing/28_1x.png`;
const Pic29 = `${FullPath}/OutdoorSwing/29_1x.png`;
const Pic30 = `${FullPath}/OutdoorSwing/30_1x.png`;
const Pic31 = `${FullPath}/OutdoorSwing/31_1x.png`;
const Pic32 = `${FullPath}/OutdoorSwing/32_1x.png`;
const Pic33 = `${FullPath}/OutdoorSwing/33_1x.png`;
const Pic34 = `${FullPath}/OutdoorSwing/34_1x.png`;
const Pic35 = `${FullPath}/OutdoorSwing/35_1x.png`;
const Pic36 = `${FullPath}/OutdoorSwing/36_1x.png`;
const Pic37 = `${FullPath}/OutdoorSwing/37_1x.png`;
const Pic38 = `${FullPath}/OutdoorSwing/38_1x.png`;
const Pic39 = `${FullPath}/OutdoorSwing/39_1x.png`;
const Pic40 = `${FullPath}/OutdoorSwing/40_1x.png`;
const Pic41 = `${FullPath}/OutdoorSwing/41_1x.png`;
const Pic42 = `${FullPath}/OutdoorSwing/42_1x.png`;
const Pic43 = `${FullPath}/OutdoorSwing/43_1x.png`;
const Pic44 = `${FullPath}/OutdoorSwing/44_1x.png`;
const Pic45 = `${FullPath}/OutdoorSwing/45_1x.png`;
const Pic46 = `${FullPath}/OutdoorSwing/46_1x.png`;
const Pic47 = `${FullPath}/OutdoorSwing/47_1x.png`;



export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,
        Pic40,
        Pic41,
        Pic42,
        Pic43,
        Pic44,
        Pic45,
        Pic46,
        Pic47,
    
    

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}